import moment from 'moment-timezone';
import { localStore } from 'helpers';
import { connect } from 'react-redux';
import store from 'store';
var instance = null;
class CommonManager {
  constructor() {
    if (instance) {
      return instance;
    }
    instance = this;
  }
  getTenant() {
    return localStore.getItem('selected-tenant');
  }
  getUserId() {
    const state = store.getState();
    // console.log(`state -->`, state.globalStateReducer.currentUser);
    if (
      state.globalStateReducer &&
      state.globalStateReducer.currentUser &&
      state.globalStateReducer.currentUser.userId
    ) {
      return state.globalStateReducer.currentUser.userId;
    }
    return '';
  }
  formDataAppend(form) {
    const formData = new FormData();
    for (let key in form) {
      this.createFormData(formData, key, form[key]);
    }
    return formData;
  }
  createFormData(formData, key, data) {
    if (data === Object(data) || Array.isArray(data)) {
      for (var i in data) {
        this.createFormData(formData, key + '[' + i + ']', data[i]);
      }
    } else {
      formData.append(key, data);
    }
  }
  UpdateTimezone() {
    if (
      localStore.getItem('timezone') === null ||
      localStore.getItem('timezone') === 'null'
    ) {
      let zone = {};
      var timeZone = moment.tz.guess();
      zone.value = timeZone;
      zone.label = zone.value;
      localStore.setItem('timezone', JSON.stringify(zone));
    }
  }
}
export default CommonManager;



// WEBPACK FOOTER //
// ./src/helpers/common.js